import Component from '../../js/lib/component';

const classList = {
  root: '.js-info',
  close: '.js-info-close'
};

export default class Info extends Component {
  events() {
    this.$.close.on('click', () => {
      this.$.root.slideUp();
    });
  }
}

Component.mount(Info, {
  name: 'Info',
  classList,
  state: {}
});
